@if (!refreshing) {
  <div>
    <h3>Inbound Call Log</h3>
    <div class="row mb-3">
      <div class="col">
        <div><strong>CLIENT</strong></div>
        <div>{{ inboundCall.client.humanizedName }}</div>
      </div>
      <div class="col">
        <div><strong>OUTBOUND FAX</strong></div>
        <div>{{ inboundCall.outboundFax?.createdAt | date: 'MM/dd/yyyy' }}</div>
        <app-office [office]="inboundCall.office"/>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div><strong>PATIENT</strong></div>
        <div>
          <app-patient-name [patient]="inboundCall.patient" [canViewPatient]="true"/>
        </div>
      </div>
      <div class="col">
        <div><strong>PRESCRIBER</strong></div>
        <div><app-prescriber-name [provider]="inboundCall.provider" [linkToProvider]="true"/></div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div><strong>OUTCOME</strong></div>
        <div>{{ keyedReasonOptions[inboundCall.reason].display }}</div>
      </div>
      <div class="col">
        <div><strong>COMMUNICATION METHOD</strong></div>
        <div>{{ inboundCall.communicationMethod | blankValueDash }}</div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div><strong>ADDITIONAL DETAILS</strong></div>
        <div class="phi">{{ inboundCall.notes | blankValueDash }}</div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div><strong>CREATED AT</strong></div>
        <div>{{ inboundCall.createdAt | date: 'M/d/yyyy h:mm a' }}</div>
      </div>
      <div class="col">
        <div><strong>CREATED BY</strong></div>
        <div>{{ inboundCall.submittedBy.fullName }}</div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6">
      <div><strong>CAPTURES</strong></div>
      @if (!loadingCaptures) {
        <div>
          @if (paginatedCaptures.meta.paging.count > 0) {
            <table class="table m-0">
              <thead>
                <tr>
                  <th>CLAIM ID</th>
                  <th>STATUS</th>
                  <th class="text-end text-nowrap">SERVICE DATE &#x25BC;</th>
                </tr>
              </thead>
              <tbody>
                @for (capture of paginatedCaptures.captures; track capture) {
                  <tr>
                    <td class="text-nowrap">
                      <a routerLink="/capture-admin/captures/{{capture.id}}" target="_blank">{{
                        capture.candidate.claimIdentifier
                      }}</a>
                    </td>
                    <td>{{ capture.status | captureStatus }}</td>
                    <td class="text-end">{{ capture.candidate.serviceDate | date: 'MM/dd/yyyy' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <p>There are no captures for this call.</p>
          }
        </div>
      } @else {
        <mat-spinner />
      }
    </div>
  </div>
  </div>
} @else {
  <mat-spinner />
}
